import moment from 'moment';
import GroupMemberModal from 'src/containers/groups/leadersView/components/groupMemberModal';
import { agGridDateCreatedAtFieldComparator } from '../../table/helpers';

const attendance = (member) =>
  Object.entries(member).filter((f) => f[0].includes('class') && Boolean(f[1])) || [];

export const GroupRowColumns = ({
  isCouples = true,
  takeattendance = false,
  isPendingNewMembers = false,
  getInfo,
}) => {
  const columns = [];

  // Date column for pending new members
  if (isPendingNewMembers) {
    columns.push({
      headerName: 'Fecha inscripción',
      field: 'createdAt',
      width: 150,
      valueGetter: (params) =>
        moment.tz(params?.data?.createdAt, 'America/Bogota').format('DD-MM-YYYY'),
      comparator: agGridDateCreatedAtFieldComparator,
      hide: false,
    });
  }

  if (isCouples) {
    columns.push({
      headerName: 'Teléfono El',
      field: 'male.phone',
      width: 150,
      valueGetter: (params) => params?.data?.male?.phone || '',
      hide: false,
    });
    columns.push({
      headerName: 'Nombre El',
      field: 'male.name',
      width: 200,
      valueGetter: (params) =>
        `${params?.data?.male?.name || ''} ${params?.data?.male?.lastName || ''}`.trim(),
      hide: false,
    });
    columns.push({
      headerName: `Teléfono Ella`,
      field: 'female.phone',
      width: 150,
      valueGetter: (params) => params?.data?.female?.phone,
      hide: false,
    });
    columns.push({
      headerName: `Nombre Ella`,
      field: 'female.name',
      width: 200,
      valueGetter: (params) =>
        `${params?.data?.female?.name || ''} ${params?.data?.female?.lastName || ''}`.trim(),
      hide: false,
    });
  } else {
    columns.push({
      headerName: 'Teléfono',
      field: 'phone',
      width: 150,
      valueGetter: (params) => params?.data?.male?.phone || params?.data?.female?.phone,
      hide: false,
    });
    columns.push({
      headerName: 'Nombre',
      field: 'name',
      width: 200,
      valueGetter: (params) =>
        `${params?.data?.male?.name || ''} ${params?.data?.male?.lastName || ''}`.trim() ||
        `${params?.data?.female?.name || ''} ${params?.data?.female?.lastName || ''}`.trim(),
      hide: false,
    });
  }
  // Attendance column
  if (takeattendance) {
    columns.push({
      headerName: 'Asistencia',
      field: 'attendance',
      width: 120,
      valueGetter: (params) => attendance(params?.data).length,
      hide: false,
    });
  }

  // Actions column
  columns.push({
    headerName: 'Ver',
    field: 'actions',
    width: 100,
    sortable: false,
    filter: false,
    cellRenderer: (params) => (
      <GroupMemberModal
        takeattendance={takeattendance}
        isCouples={isCouples}
        member={params?.data}
        getInfo={getInfo}
        isPendingNewMembers={isPendingNewMembers}
      />
    ),
    hide: false,
  });

  return columns;
};
